import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesInventarios() {
  const { user } = useContext(AuthContext);

  const SECCIONES = [
    { section: "Existencias", items: [
      { label: "Inventario", icon: "fas fa-warehouse", color: "#06b6d4", href: "/ListadoInventarios", desc: "Existencia por area", enabled: !!user.inventarios },
      { label: "Inventario Costos", icon: "fas fa-warehouse", color: "#14b8a6", href: "/ListadoInventariosCostos", desc: "Valorizado", enabled: !!user.inventarios },
      { label: "Disponible", icon: "fas fa-tasks", color: "#3b82f6", href: "/ListadoDisponible", desc: "Disponible general", enabled: !!user.menu_disponible },
    ]},
    { section: "Movimientos", items: [
      { label: "Ajuste Inventario", icon: "fas fa-plus", color: "#8b5cf6", href: "/ListadoAjustesInventario", desc: "Ajustes de existencia", enabled: !!user.ajustesInventario },
      { label: "Almacenes", icon: "fas fa-warehouse", color: "#64748b", href: "/Areas", desc: "Bodegas y almacenes", enabled: !!user.menu_areas },
    ]},
    { section: "Seguimiento", items: [
      { label: "Kardex", icon: "fas fa-clipboard-list", color: "#6366f1", href: "/ListadoKardex", desc: "Movimientos por modelo", enabled: !!user.seguimiento_inventarios },
      { label: "Lotes", icon: "fas fa-tags", color: "#6366f1", href: "/ListadoLotes", desc: "Lotes, caducidad y a quien se vendio", enabled: !!user.menu_inventarios },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Inventarios"
      descripcion="Existencias, movimientos y seguimiento"
      icono="fas fa-warehouse"
      color="#06b6d4"
      secciones={SECCIONES}
    />
  );
}

export default BotonesInventarios;
